import AbstractValidator from './AbstractValidator';

export default class BuyerReference extends AbstractValidator
{
    protected messageTemplates: Record<string, string> = {
        invalidType: 'Die Leitweg-Id hat einen unbekannten Datentyp',
        invalidFormat: '%value% ist nicht im richtigem Format (12345-123abc-00 oder 12345-00)',
        invalidBasic: 'Die Globaladressierung von %value% ist fehlerhaft',
        invalidSpecific: 'Die Feinadressierung von %value% ist fehlerhaft',
        invalidCheck: 'Die Prüfziffer von %value% ist fehlerhaft',
    };

    run()
    {
        const value = this.value;

        // based on https://xeinkauf.de/app/uploads/2022/11/Leitweg-ID-Formatspezifikation-v2-0-2-1.pdf page 5 "Aufbau der Leitweg-ID"
        if (typeof value !== 'string')
        {
            this.error = this.getMessage('invalidType');
            return false;
        }

        const buyerReferenceParts = value.split('-');
        const count               = buyerReferenceParts.length;

        if (count < 2 || count > 3)
        {
            this.error = this.getMessage('invalidFormat');
            return false;
        }

        const numberRegex = /^\d+$/;

        const basic = buyerReferenceParts[0];
        let specific;
        let check;

        if (count === 2)
        {
            specific = '';
            check    = buyerReferenceParts[1];
        }
        else
        {
            specific = buyerReferenceParts[1];
            check    = buyerReferenceParts[2];
        }

        if (basic.length > 12 || !numberRegex.test(basic))
        {
            this.error = this.getMessage('invalidBasic');
            return false;
        }

        if (specific.length > 30)
        {
            this.error = this.getMessage('invalidSpecific');
            return false;
        }

        if (check.length !== 2 || !numberRegex.test(check))
        {
            this.error = this.getMessage('invalidCheck');
            return false;
        }

        let checksum = basic;
        const chars  = specific.split('');

        for (const char of chars)
        {
            if (numberRegex.test(char))
            {
                checksum += char;
            }
            else if (/[a-zA-Z]/.test(char))
            {
                checksum += char.toLowerCase().charCodeAt(0) - 'a'.charCodeAt(0) + 10;
            }
            else
            {
                this.error = this.getMessage('invalidSpecific');
                return false;
            }
        }
        checksum += check;

        if (BigInt(checksum) % BigInt(97) !== BigInt(1))
        {
            this.error = this.getMessage('invalidCheck');
            return false;
        }

        return true;
    }
}